export default "__VITE_ASSET__B$hCPCMC__"